import React, { useEffect, useState } from "react";
import Api from "../Api";
import { BASE_API_URL } from "../const";
import filmStore from "../../Store/FilmStore";
import { observer } from "mobx-react-lite";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Button,
  TextField,
  Typography,
  Modal,
  Select,
  MenuItem,
  FormControlLabel,
  Checkbox,
  IconButton,
  CircularProgress,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import AdsClick from "@mui/icons-material/AdsClick";
import { toast } from "react-toastify";
import { toJS } from "mobx";

const MainBodyModal = ({
  openModal,
  handleCloseModal,
  responseAPI,
  selectedFormat,
  repeatLastFilmListRequest,
  getDataListChannels,
}) => {
  const [selectedChannelName, setSelectedChannelName] = useState("");
  const [selectedValue, setSelectedValue] = useState("");
  const [checkboxValues, setCheckboxValues] = useState([]);
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
  const [formData, setFormData] = useState({
    channel_id: null,
    files_id: [],
  });
  const [responseListChannels, setResponseListChannels] = useState();
  const [selectedSeasons, setSelectedSeasons] = useState([]);
  const [seasons, setSeasons] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [isDisabled, setIsDisabled] = useState(true);
  const [borderColorMet, setBorderColorMet] = useState("gray");
  const [labelText, setLabelText] = useState("met_uid");
  const [isEditMetUid, setIsEditMetUid] = useState(false);
  const [sortByEpisode, setSortByEpisode] = useState(true);
  const [sendSuccess, setSendSuccess] = useState(false);
  const [isLoadingMet, setIsLoadingMet] = useState(false);

  useEffect(() => {
    setInputValue(responseAPI.met_uid ?? "");
    getDataListChannels();
    if (!responseAPI.serial) {
      setFormData({
        channel_id: null,
        files_id: [responseAPI.files[0].file_id],
      });
    } else {
      setFormData({ channel_id: null, files_id: [] });
    }
  }, []);

  useEffect(() => {
    if (responseAPI) {
      setInputValue(responseAPI.met_uid ?? "");
      const uniqueSeasons = [
        ...new Set(responseAPI.files.map((file) => file.season)),
      ];
      setSeasons(uniqueSeasons);
    }
    setSelectedValue("");
    setSelectedCheckboxes([]);
    setSelectedSeasons([]);
    setCheckboxValues([]);
    selectSeason([]);
    if (!responseAPI.serial) {
      setFormData({
        channel_id: null,
        files_id: [responseAPI.files[0].file_id],
      });
    } else {
      setFormData({ channel_id: null, files_id: [] });
    }
  }, [responseAPI]);

  useEffect(() => {
    setSelectedCheckboxes([]);
    setSelectedSeasons([]);
    setCheckboxValues([]);
    selectSeason([]);
    if (responseAPI) {
      setInputValue(responseAPI.met_uid ?? "");
    }
  }, [selectedFormat, selectedChannelName]);

  useEffect(() => {
    if (responseAPI.serial) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        files_id: selectedCheckboxes,
      }));
    }
  }, [selectedCheckboxes]);

  useEffect(() => {
    if (isEditMetUid && inputValue === responseAPI.met_uid) {
      setIsDisabled(false);
    } else {
      setIsDisabled(
        inputValue === "" ||
          labelText === "изменено" ||
          inputValue === responseAPI.met_uid
      );
    }
  }, [inputValue]);

  useEffect(() => {
    setSelectedCheckboxes([]);
    setSelectedSeasons([]);
    setCheckboxValues([]);
    selectSeason([]);
    setSendSuccess(false);
    if (responseAPI.met_uid) {
      setBorderColorMet("blue");
    } else {
      setBorderColorMet("gray");
    }
  }, [responseAPI.title]);

  useEffect(() => {
    if (openModal && !responseAPI.serial) {
      const ids = responseAPI.files
        .filter((file) => file.format === selectedFormat)
        .map((file) => file.file_id);
      setFormData({ ...formData, files_id: ids });
    }
  }, [openModal, selectedFormat]);

  async function getDataListChannels() {
    try {
      const response = await Api.get(`${BASE_API_URL}/api/channel/list`);
      setResponseListChannels(response.data.data);
    } catch (error) {
      console.error(error);
    }
  }

  const handleSelectChange = (event) => {
    setSelectedValue(event.target.value);
    setFormData((prevFormData) => ({
      ...prevFormData,
      channel_id: event.target.value,
    }));
  };

  const handleCheckboxChange = (id, season) => {
    setSelectedCheckboxes((prev) => {
      const isRemoving = prev.includes(id);
      const updatedCheckboxes = isRemoving
        ? prev.filter((item) => item !== id)
        : [...prev, id];

      setSelectedSeasons((prevSeasons) => {
        if (!isRemoving) {
          return prevSeasons.includes(season)
            ? prevSeasons
            : [...prevSeasons, season];
        } else {
          const hasOtherCheckboxesForSeason = updatedCheckboxes.some(
            (checkboxId) => {
              const checkboxSeason = getSeasonByCheckboxId(checkboxId);
              return checkboxSeason === season;
            }
          );
          return hasOtherCheckboxesForSeason
            ? prevSeasons
            : prevSeasons.filter((s) => s !== season);
        }
      });

      return updatedCheckboxes;
    });
  };

  const getSeasonByCheckboxId = (checkboxId) => {
    if (!Array.isArray(responseAPI.files)) return null;
    const film = responseAPI.files.find((file) => file.file_id === checkboxId);
    return film ? film.season : null;
  };

  const filterFilesByFormat = (fileIds, files, format) => {
    return fileIds.filter((fileId) => {
      const file = files.find((f) => f.file_id === fileId);
      return file && file.format === format;
    });
  };

  // === НОВАЯ ФУНКЦИЯ ===
  const fetchMetUidFromMbase = async () => {
    if (!responseAPI?.id) {
      toast.error("ID контента не найден");
      return;
    }

    setIsLoadingMet(true);

    const isSerial = Boolean(responseAPI.serial);
    const endpoint = isSerial
      ? `${BASE_API_URL}/api/met/serial`
      : `${BASE_API_URL}/api/met/film`;

    try {
      const response = await Api.post(endpoint, {
        mbase_id: responseAPI.id,
      });

      // ←←← ИСПРАВЛЕНИЕ ЗДЕСЬ ←←←
      const newMetUid = response?.data?.data?.met_uid;

      if (newMetUid) {
        setInputValue(String(newMetUid));
        setLabelText("met_uid (получено)");
        setBorderColorMet("green");
        setIsEditMetUid(true);
        toast.success(`met_uid успешно получен: ${newMetUid}`);
      } else {
        toast.warning("В ответе от сервера не найден met_uid");
      }
    } catch (error) {
      console.error("Ошибка при получении met_uid:", error);
      const msg =
        error?.response?.data?.message ||
        error?.response?.data?.error?.message ||
        error?.message ||
        "Не удалось получить met_uid";
      toast.error(`❌ ${msg}`);
    } finally {
      setIsLoadingMet(false);
    }
  };

  const handleSend = async () => {
    try {
      const response = await Api.post(
        `${BASE_API_URL}/api/movie/met/${responseAPI.id}`,
        {
          met_uid: inputValue,
        }
      );

      if (response.status === 200) {
        repeatLastFilmListRequest();
        setLabelText("изменено");
        setBorderColorMet("blue");
        setIsDisabled(true);
        setIsEditMetUid(true);
        toast.success("met_uid успешно изменён");
      }
    } catch (error) {
      toast.error("Ошибка при изменении met_uid");
    }
  };

  const selectSeason = (seasonNumber) => {
    if (responseAPI) {
      const seasonFiles = responseAPI.files
        .filter((file) => file.season === seasonNumber)
        .map((file) => file.file_id);

      setSelectedCheckboxes((prevSelected) => {
        const updatedSelection = [
          ...new Set([...prevSelected, ...seasonFiles]),
        ];
        return updatedSelection;
      });
    }
  };

  const handleCheckboxChangeSeason = (event, season) => {
    const { checked } = event.target;
    setSelectedSeasons((prevSelected) =>
      checked
        ? [...prevSelected, season]
        : prevSelected.filter((s) => s !== season)
    );

    if (checked) {
      selectSeason(season);
    } else {
      const seasonFiles = responseAPI.files
        .filter((file) => file.season === season)
        .map((file) => file.file_id);

      setSelectedCheckboxes((prevSelected) =>
        prevSelected.filter((fileId) => !seasonFiles.includes(fileId))
      );
    }
  };

  const handleCheckboxChangeSortByEpisode = () => {
    setSortByEpisode((v) => !v);
  };

  const handleClickSendData = () => {
    if (
      formData.channel_id !== null &&
      Array.isArray(formData.files_id) &&
      formData.files_id.length > 0
    ) {
      const filteredFileIds = filterFilesByFormat(
        formData.files_id,
        responseAPI.files,
        selectedFormat
      );

      formData.files_id = filteredFileIds;

      if (sortByEpisode) {
        const episodeMap = new Map(
          responseAPI.files.map((item) => [
            item.file_id,
            { season: item.season, episode: item.episode },
          ])
        );

        formData.files_id.sort((a, b) => {
          const dataA = episodeMap.get(a);
          const dataB = episodeMap.get(b);
          if (dataA.season === dataB.season) {
            return dataA.episode - dataB.episode;
          }
          return dataA.season - dataB.season;
        });
      }
    }

    Api.post(`${BASE_API_URL}/api/timeline/add`, formData)
      .then((response) => {
        // ... твой оригинальный код формирования successMessage ...
        const responseArray = Array.isArray(responseAPI)
          ? responseAPI.slice().map((item) => toJS(item))
          : [toJS(responseAPI)];

        const filesArray = [];
        responseArray.forEach((item) => {
          if (item.files && Array.isArray(item.files)) {
            filesArray.push(...item.files.map((file) => toJS(file)));
          }
        });

        const sentItems = (formData.files_id || [])
          .map((fileId) => {
            const fileData = filesArray.find((f) => f.file_id == fileId);
            if (!fileData) return null;

            const parentItem = responseArray.find((item) =>
              item.files?.some((f) => f.file_id == fileId)
            );

            const isSeries = fileData.season > 0 || fileData.episode > 0;

            return {
              title: parentItem?.title || parentItem?.name || "Без названия",
              type: isSeries ? "series" : "movie",
              season: fileData.season || 0,
              episode: fileData.episode || 0,
            };
          })
          .filter(Boolean);

        let successMessage = "Добавлено: ";
        if (sentItems.length === 1) {
          const item = sentItems[0];
          successMessage +=
            item.type === "series"
              ? `${item.title} (Сезон ${item.season}, Серия ${item.episode})`
              : item.title;
        } else {
          const titles = sentItems.map((item) =>
            item.type === "series"
              ? `${item.title} (С${item.season}E${item.episode})`
              : item.title
          );
          successMessage += titles.slice(0, 3).join(", ");
          if (titles.length > 3)
            successMessage += ` и ещё ${titles.length - 3}`;
        }

        setFormData({ channel_id: null, files_id: [] });
        setSelectedCheckboxes([]);
        setSelectedSeasons([]);
        selectSeason([]);
        setCheckboxValues([]);
        setSelectedValue("");
        filmStore.getDataListChannels();
        setSendSuccess(true);

        toast.success(successMessage);
      })
      .catch((error) => {
        const msg =
          error?.response?.data?.error?.message ||
          error?.message ||
          "transfer bad";
        toast.error(`❌ ${msg}`);
      })
      .finally(() => {
        handleCloseModal();
      });
  };

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
    setLabelText("met_uid");
    setBorderColorMet("red");
  };

  return (
    <Modal
      open={openModal}
      onClose={() => {
        setSelectedCheckboxes([]);
        setSelectedSeasons([]);
        selectSeason([]);
        handleCloseModal();
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 575,
          maxWidth: 575,
          minWidth: 575,
          maxHeight: "90vh",
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 24,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box sx={{ p: 4, pb: 0, flex: 1, overflowY: "auto" }}>
          <Paper
            sx={{
              backgroundColor: "#E0F7FA",
              padding: 1,
              borderRadius: 2,
              marginBottom: 2,
              width: 480,
              maxWidth: 480,
              minWidth: 480,
            }}
          >
            <Typography variant="h6" align="center" color="primary">
              {responseAPI.title} - {selectedFormat}
            </Typography>
          </Paper>

          <Paper
            sx={{
              backgroundColor: "#E0F7FA",
              padding: 1,
              borderRadius: 2,
              width: 480,
              maxWidth: 480,
              minWidth: 480,
              overflowX: "auto",
            }}
          >
            {responseAPI && responseListChannels && (
              <TableContainer>
                <Table>
                  <TableBody>
                    <TableRow>
                      <TableCell>
                        <Select
                          value={selectedValue}
                          onChange={handleSelectChange}
                          displayEmpty
                          fullWidth
                        >
                          <MenuItem value="">
                            <em>Выберите канал</em>
                          </MenuItem>
                          {responseListChannels.map((element, index) => (
                            <MenuItem key={index} value={element.id}>
                              {element.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </TableCell>
                    </TableRow>

                    {responseAPI.serial && (
                      <TableRow>
                        <TableCell colSpan={seasons.length}>
                          <Box display="flex" flexWrap="wrap" maxWidth="400px">
                            {seasons.map((season) => (
                              <FormControlLabel
                                key={season}
                                control={
                                  <Checkbox
                                    checked={selectedSeasons.includes(season)}
                                    onChange={(event) =>
                                      handleCheckboxChangeSeason(event, season)
                                    }
                                  />
                                }
                                label={`Сезон ${season}`}
                                sx={{ flexShrink: 0 }}
                              />
                            ))}
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={sortByEpisode}
                                  onChange={handleCheckboxChangeSortByEpisode}
                                />
                              }
                              label={"Сортировка по порядку"}
                              sx={{ flexShrink: 0 }}
                            />
                          </Box>
                        </TableCell>
                      </TableRow>
                    )}

                    <TableRow>
                      <TableCell
                        colSpan={seasons.length + 1}
                        sx={{ maxWidth: 390 }}
                      >
                        {/* Поле met_uid с новой иконкой */}
                        <Box sx={{ mb: 3 }}>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1.5,
                            }}
                          >
                            <TextField
                              label={labelText}
                              variant="outlined"
                              value={inputValue}
                              onChange={handleInputChange}
                              fullWidth
                              autoComplete="off"
                              inputProps={{ form: "off" }}
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  "& fieldset": { borderColor: borderColorMet },
                                  "&:hover fieldset": {
                                    borderColor: borderColorMet,
                                  },
                                  "&.Mui-focused fieldset": {
                                    borderColor: borderColorMet,
                                  },
                                },
                                maxWidth: "380px", // укороченное поле
                              }}
                            />

                            <IconButton
                              color="primary"
                              onClick={fetchMetUidFromMbase}
                              disabled={isLoadingMet}
                              title="Получить met_uid из mbase"
                              sx={{ width: 48, height: 48 }}
                            >
                              {isLoadingMet ? (
                                <CircularProgress size={24} />
                              ) : (
                                <AdsClick sx={{ fontSize: 34 }} />
                              )}
                            </IconButton>
                          </Box>
                        </Box>

                        {/* Кнопка "изменить met_uid" */}
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            mb: 3,
                          }}
                        >
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={handleSend}
                            disabled={isDisabled}
                          >
                            изменить met_uid
                          </Button>
                        </Box>

                        {responseAPI.files.some(
                          (file) => file.episode === 111
                        ) && (
                          <Typography
                            variant="subtitle1"
                            color="error"
                            align="center"
                            sx={{ fontWeight: "bold", marginBottom: "8px" }}
                          >
                            ❗ есть 111 серия!
                          </Typography>
                        )}

                        {responseAPI.serial && (
                          <Box
                            sx={{
                              border: "1px solid #ddd",
                              borderRadius: "4px",
                              padding: "6px",
                              marginBottom: "16px",
                              width: "95%",
                              minHeight: "50px",
                            }}
                          >
                            <Typography
                              variant="caption"
                              sx={{
                                display: "block",
                                fontSize: "12px",
                                marginBottom: "4px",
                                textAlign: "center",
                                color: "gray",
                              }}
                            >
                              Выбранные серии
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{
                                fontSize: "14px",
                                lineHeight: "1.4",
                                textAlign: "center",
                              }}
                            >
                              {selectedSeasons
                                .map((season) => {
                                  const selectedFiles = responseAPI.files
                                    .filter(
                                      (file) =>
                                        file.season === season &&
                                        file.format === selectedFormat &&
                                        selectedCheckboxes.includes(
                                          file.file_id
                                        )
                                    )
                                    .map((file) => file.episode);

                                  if (selectedFiles.length === 0) return null;

                                  const groupedSeries = [];
                                  let rangeStart = null;

                                  for (
                                    let i = 0;
                                    i < selectedFiles.length;
                                    i++
                                  ) {
                                    if (rangeStart === null) {
                                      rangeStart = selectedFiles[i];
                                    }

                                    if (
                                      selectedFiles[i + 1] !==
                                        selectedFiles[i] + 1 ||
                                      i === selectedFiles.length - 1
                                    ) {
                                      if (rangeStart === selectedFiles[i]) {
                                        groupedSeries.push(`${rangeStart}`);
                                      } else {
                                        groupedSeries.push(
                                          `${rangeStart}-${selectedFiles[i]}`
                                        );
                                      }
                                      rangeStart = null;
                                    }
                                  }

                                  return `Сезон ${season}, серии ${groupedSeries.join(
                                    ", "
                                  )}`;
                                })
                                .filter(Boolean)
                                .join("; ")}
                            </Typography>
                          </Box>
                        )}

                        {responseAPI.serial ? (
                          <Box
                            sx={{
                              display: "grid",
                              gridTemplateColumns: `repeat(${seasons.length}, 1fr)`,
                              maxHeight: "400px",
                              maxWidth: 440,
                              minWidth: 440,
                              width: 400,
                              overflowY: "auto",
                              overflowX: "auto",
                            }}
                          >
                            {seasons.map((season) => {
                              const seasonFiles = responseAPI.files.filter(
                                (file) =>
                                  file.season === season &&
                                  file.format === selectedFormat
                              );

                              return (
                                <Box
                                  key={season}
                                  sx={{
                                    border: "1px solid #ddd",
                                    padding: "2px",
                                  }}
                                >
                                  <Typography
                                    variant="subtitle1"
                                    align="center"
                                    sx={{
                                      marginBottom: "8px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Сезон {season}
                                  </Typography>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      flexDirection: "column",
                                    }}
                                  >
                                    {seasonFiles.map((file) => (
                                      <FormControlLabel
                                        key={file.file_id}
                                        control={
                                          <Checkbox
                                            checked={selectedCheckboxes.includes(
                                              file.file_id
                                            )}
                                            onChange={() =>
                                              handleCheckboxChange(
                                                file.file_id,
                                                file.season
                                              )
                                            }
                                            sx={{ padding: "1px" }}
                                          />
                                        }
                                        label={
                                          <Box
                                            component="span"
                                            sx={{
                                              fontSize: "11px",
                                              lineHeight: "1.2",
                                            }}
                                          >
                                            серия {file.episode}
                                          </Box>
                                        }
                                        sx={{ margin: 0 }}
                                      />
                                    ))}
                                  </Box>
                                </Box>
                              );
                            })}
                          </Box>
                        ) : (
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "flex-start",
                              padding: "8px",
                              maxHeight: "300px",
                              overflowY: "auto",
                              rowGap: "4px",
                            }}
                          >
                            {responseAPI.files
                              .filter((file) => file.format === selectedFormat)
                              .map((file) => (
                                <FormControlLabel
                                  key={file.file_id}
                                  control={
                                    <Checkbox
                                      checked={true}
                                      sx={{ padding: "4px" }}
                                    />
                                  }
                                  label={file.name}
                                  sx={{ margin: 0 }}
                                />
                              ))}
                          </Box>
                        )}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </Paper>
        </Box>

        <Box
          sx={{
            textAlign: "center",
            mt: 2,
            mb: 2,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Button
            onClick={handleClickSendData}
            variant="contained"
            color="primary"
            disabled={
              !(
                formData.channel_id !== null &&
                Array.isArray(formData.files_id) &&
                formData.files_id.length > 0
              )
            }
          >
            Отправить
          </Button>
          {sendSuccess && (
            <CheckIcon sx={{ color: "green", fontSize: 24, marginLeft: 1 }} />
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default observer(MainBodyModal);
